import { EditorState, Modifier } from "draft-js";

//Function that insert value into the editor after the cursor

export const insertText = (text, editorValue) => {
  const currentContent = editorValue.getCurrentContent();
  const currentSelection = editorValue.getSelection();

  const newContent = Modifier.replaceText(
    currentContent,
    currentSelection,
    text
  );

  const newEditorState = EditorState.push(
    editorValue,
    newContent,
    "insert-characters"
  );
  return EditorState.forceSelection(
    newEditorState,
    newContent.getSelectionAfter()
  );
};

export const toolbarOptions = () => {
  const toolbarOpts = {
    options: [
      "inline",
      "blockType",
      "fontSize",
      "fontFamily",
      "list",
      "textAlign",
    ],
    inline: {
      inDropdown: false,
      className: undefined,
      component: undefined,
      dropdownClassName: undefined,
      options: ["bold", "italic", "underline", "strikethrough"],
    },
    blockType: {
      inDropdown: true,
      options: [
        "Normal",
        "H1",
        "H2",
        "H3",
        "H4",
        "H5",
        "H6",
        "Blockquote",
        "Code",
      ],
      className: undefined,
      component: undefined,
      dropdownClassName: undefined,
    },
    fontSize: {
      options: [8, 9, 10, 11, 12, 14, 16, 18, 24, 30, 36, 48, 60, 72, 96],
      className: undefined,
      component: undefined,
      dropdownClassName: undefined,
    },
    fontFamily: {
      options: [
        "Arial",
        "Georgia",
        "Impact",
        "Tahoma",
        "Times New Roman",
        "Verdana",
      ],
      className: undefined,
      component: undefined,
      dropdownClassName: undefined,
    },
    list: {
      inDropdown: false,
      className: undefined,
      component: undefined,
      dropdownClassName: undefined,
      options: ["unordered", "ordered", "indent", "outdent"],
    },
    textAlign: {
      inDropdown: false,
      className: undefined,
      component: undefined,
      dropdownClassName: undefined,
      options: ["left", "center", "right", "justify"],
    },
  };
  return toolbarOpts;
};

export const ButtonValues = () => {
  let values = [
    {
      text: "`Ονομα",
      value: "{{Name}}",
    },
    {
      text: "Επίθετο",
      value: "{{Surname}}",
    },
    {
      text: "ΑΦΜ",
      value: "{{AFM}}",
    },
    {
      text: "Αρ.Ταυτότητας",
      value: "{{ADT}}",
    },
    {
      text: "ΑΜΚΑ",
      value: "{{AMKA}}",
    },
    {
      text: "ΜΕΘ",
      value: "{{Meth}}",
    },
    {
      text: "Επώνυμο Πατέρα",
      value: "{{Father Surname}}",
    },
    {
      text: "Όνομα Πατέρα",
      value: "{{Father Name}}",
    },
    {
      text: "Επώνυμο Μητρός",
      value: "{{Mother Surname}}",
    },
    {
      text: "Όνομα Μητρός",
      value: "{{Mother Name}}",
    },
    {
      text: "Ημ.Γέννησης",
      value: "{{Βirth Date}}",
    },
    {
      text: "Τόπος Γέννησης",
      value: "{{Birth Place}}",
    },
    {
      text: "Διεύθυνση",
      value: "{{Address}}",
    },
    {
      text: "Αριθμός Διεύθυνσης",
      value: "{{Address number}}",
    },
    {
      text: "T.K.",
      value: "{{Postal Code}}",
    },
    {
      text: "Αριθμός Τηλεφώνου",
      value: "{{Phone Number}}",
    },
    {
      text: "Αριθμός Κινητού Τηλεφώνου",
      value: "{{Mobile Phone Number}}",
    },
    {
      text: "Email",
      value: "{{Email}}",
    },
    {
      text: "Σημερινή ημερομηνία",
      value: "{{Now Date}}",
    },
  ];

  return values;
};
